import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../reducers/rootReducer';
import { redirectSelectors } from '../../../reducers/redirectSlice';

/** Hook listens for redirect that could be initiated through saga generator function */
const useRedirectListener = () => {
  const redirect = useAppSelector(redirectSelectors.selectRedirect);
  const navigate = useNavigate();

  useEffect(() => {
    if (redirect) {
      navigate(redirect.destination + (redirect.search || ''), {
        state: redirect.state,
        replace: true,
      });
    }
  }, [redirect]);
};

export default useRedirectListener;
